module.exports = __webpack_public_path__ + "static/media/technologies.66d12224.png";